import {http} from './config';

export default {
    index: page => http.get('api/v1/configuracao-calculadora', {params: {page}}),

    create: data => http.post('api/v1/configuracao-calculadora', data),

    show: (id, params = {}) => http.get(`api/v1/configuracao-calculadora/${id}`, {params}),

    list: () => http.get('api/v1/configuracao-calculadora/list'),

    update: data => http.put(`api/v1/configuracao-calculadora/${data.id}`, data),

    updateFields: data => http.patch(`api/v1/configuracao-calculadora/${data.id}`, data),

    delete: id => http.delete(`api/v1/configuracao-calculadora/${id}`),

    duplicate: id => http.get(`api/v1/configuracao-calculadora/duplicar/${id}`),

    listInstallmentPosition: allotmentId => http.get(allotmentId ? `api/v1/configuracao-calculadora/list-installment-position/${allotmentId}`
        : 'api/v1/configuracao-calculadora/list-installment-position'),
};
